<!--
 * @Author: your name
 * @Date: 2021-09-14 13:49:44
 * @LastEditTime: 2021-09-22 17:40:08
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/personalCenter/myIndent/indentDetail/components/productList.vue
-->
<!--  -->
<template>
  <div>
    <div class="content" v-for="(item, index) in productVOList" :key="index">
      <div class="text">
        <div class="product_name">
          <span class="card" v-if="item.discountType">
            {{ selectPromotionLabel(item.discountType, item.promotionLabel) }}
          </span>
          <i v-if="item.productName.substr(0, 1) == '【'" class="title-special-processing" />
          {{ item.productName }}
        </div>
        <span class="pice" v-if="!hasAccommodationProduct(productVOList)">￥{{ item.sellPrice }}</span>
      </div>
      <span class="sku_name" v-if="item.skuName && !item.isDefault">{{
        item.skuNewName.toString()
      }}</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    productVOList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    selectPromotionLabel() {
      return (discountType, promotionLabel) => {
        switch (discountType) {
          case 1: // 单品促销
            if (promotionLabel === 1) {
              return '折后价';
            }
            return '秒杀';
          case 2:
            return '联报';
          case 5:
            return '满减';
          default:
            return null;
        }
      };
    },
  },
  watch: {},
  methods: {
    hasAccommodationProduct(orderProductList) {
      const flag =orderProductList?.some((item) => item && item.isAccommodation === 1);

      return flag;
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  flex-direction: column;
  margin-bottom: 22px;

  .text {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .card {
      display: inline-block;
      min-width: 65px;
      height: 33px;
      margin: 6px 14px 0 0;
      color: $bgWhite;
      font-size: 22px;
      line-height: 33px;
      text-align: center;
      background: $theme_color;
      border: 1px solid $theme_color;
      border-radius: 7px;
    }

    div {
      display: flex;
    }

    .product_name {
      max-height: 90px;
      margin-right: 20px;
      font-size: 25px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 36px;

      @extend .ellipsis-2;
    }
    .deal {
      width: 426px;
      height: 36px;
      color: $fontColorBlackLight;
      font-size: 25px;
      line-height: 36px;
    }
    // span {
    //   display: flex;
    //   align-items: center;
    //   justify-content: center;
    //   width: 65px;
    //   height: 33px;
    //   margin-right: 14px;
    //   color: $theme_color;
    //   font-size: 22px;
    //   line-height: 31px;
    //   border:2px solid $theme_color;
    //   border-radius: 7px;
    // }
  }

  .sku_name {
    margin-top: 10px;
    font-size: 25px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #999999;
    line-height: 36px;
  }
  .pice {
    // width: 22%;
    font-size: 25px;
    line-height: 29px;
    // @extend .ellipsis-2;
  }
}
</style>
